// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ac-data-node-list-form-create{width:100%;min-width:600px}.ac-data-node-list-form-create .ac-form{padding-top:1rem}.ac-data-node-list-form-create .ac-form__actions{background:#F9F9F9;justify-content:flex-end;margin-top:25px;padding-bottom:10px;padding-top:10px;padding-right:2rem}.ac-data-node-list-form-create .ac-form__actions .ac-button{margin-top:0}\n", ""]);
// Exports
module.exports = exports;
